import ManageOutlets from './ManageOutlets';

export default ManageOutlets;
